import React from 'react';

interface Props {
    color?: string;
    height?: number;
    hasOpacity?: boolean;
}

const Separation: React.FC<Props>  = ({ color, height, hasOpacity }) => {
  return (
    <div
          style={{ backgroundColor: color, height: `${height}px`, opacity: hasOpacity && '0.6' }}
        ></div>
  )
}

export default Separation;
